import { render, staticRenderFns } from "./ImplementationPanelTBM.vue?vue&type=template&id=70bea452&scoped=true&"
import script from "./ImplementationPanelTBM.vue?vue&type=script&lang=js&"
export * from "./ImplementationPanelTBM.vue?vue&type=script&lang=js&"
import style0 from "./ImplementationPanelTBM.vue?vue&type=style&index=0&id=70bea452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bea452",
  null
  
)

export default component.exports